export const UNIT_SETTINGS_GET_UNIT_GROUPS = "UNIT_SETTINGS_GET_UNIT_GROUPS";
export const UNIT_SETTINGS_GET_UNIT_GROUPS_RESPONSE = "UNIT_SETTINGS_GET_UNIT_GROUPS_RESPONSE";
export const UNIT_SETTINGS_UPDATE_MULTIPLE_UNITS = "UNIT_SETTINGS_UPDATE_MULTIPLE_UNITS";
export const UNIT_SETTINGS_UPDATE_MULTIPLE_UNITS_RESPONSE = "UNIT_SETTINGS_UPDATE_MULTIPLE_UNITS_RESPONSE";